import { useState } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  addStep: () => void
}

export const AddStepButton = ({ addStep }: Props) => {
  const [hover, setHover] = useState(false)
  return (
    <Box
      onClick={addStep}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      paddingX="s24"
      paddingY="s8"
      cursor="pointer"
      background={hover ? 'grey200' : 'grey100'}
      border={{ all: { style: 'dashed', width: 's2', color: 'grey400' } }}
      style={{ borderSpacing: '240px' }}
      borderRadius={{ all: 'abs008' }}
      justifyContent="spaceBetween"
      alignItems="center"
    >
      <Box flexDirection="row" alignItems="center" gap="s6" justifyContent="center">
        <Icon.Medium icon="add" color="grey800" />
        <Text.Normal size="200" weight="medium" color="grey800">
          {i18n.t('settings.approvals.approval_level.add_button')}
        </Text.Normal>
      </Box>
    </Box>
  )
}
